import React, { useEffect } from 'react'
import ContentBox from '../components/ContentBox'

export default function Staff() {

  useEffect(() => {
    document.getElementById('toggle-menu').className = 'theme-blush ls-toggle-menu';
  }, []);

  return (
    <>
      <section className='content' style={{ marginBottom: '-80px' }}>
        <div className='block-header'>
          <div className='row'>
            <div className='col-lg-7 col-md-6 col-sm-12'>
              <h2>INFORMAÇÕES SOBRE O PROJETO</h2><small className='text-muted'> EQUIPE DE DESENVOLVIMENTO E TECNOLOGIAS UTILIZADAS  </small>
            </div>
          </div>
        </div>
      </section>
      <ContentBox>
        <div className="row clearfix">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="card">
              <div className="header">
                <h2><i className='zmdi zmdi-accounts'></i> ENVOLVIDOS NO PROJETO <small> DIREI E ATIC, EM ESPECIAL: </small> </h2>
              </div>
              <div className="body table-responsive members_profiles">
                <table className="table table-hover table-sm small">
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'center' }}> <i className='zmdi zmdi-account-o'></i></th>
                      <th>  MEMBRO </th>
                      <th>CARGO</th>
                      <th>FUNÇÃO NO PROJETO</th>
                      <th>CONTATO</th>
                    </tr>
                  </thead>
                  <tbody>

                    <tr>
                      <td>
                        {/* <img className="rounded-circle" src="assets/images/xs/rodrigo_iede_avatar_50x50.jpg" alt="user" width="40" /> */}
                      </td>
                      <td>
                        <a href="javascript:void(0);" className='text-danger'> Glauber Flaviano Silveira
 </a>
                      </td>
                      <td> Pesquisador </td>
                      <td>Analista </td>
                      <td>
                        <div className="u_name">
                          <i className="c_name"> <i className="zmdi zmdi-email"></i> glauber.silveira@fjp.mg.gov.br </i>
                          <br />
                          {/* <i className="phone"><i className="zmdi zmdi-phone"></i><span className='ml-1'>(31) 98654-5323</span></i> */}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        {/* <img className="rounded-circle" src="assets/images/xs/anibal_atic_avatar_50x50.jpg" alt="user" width="40" /> */}
                      </td>
                      <td>
                        <a href="javascript:void(0);" className='text-danger'>Allan Quintão</a>
                      </td>
                      <td>Gestor ATIC</td>
                      <td>Coordenador</td>
                      <td>

                        <div className="u_name">
                          <i className="c_name"> <i className="zmdi zmdi-email"></i> allan.quintao@fjp.mg.gov.br </i>
                          <br />
                          {/* <i className="phone"><i className="zmdi zmdi-phone"></i><span className='ml-1'>(33) 98803-1302</span></i> */}
                        </div>


                      </td>
                    </tr>
                    <tr>
                      <td>
                        {/* <img className="rounded-circle" src="assets/images/xs/anibal_atic_avatar_50x50.jpg" alt="user" width="40" /> */}
                      </td>
                      <td>
                        <a href="javascript:void(0);" className='text-danger'>Aníbal Ferreira Filho</a>
                      </td>
                      <td>Analista de Sistemas</td>
                      <td>Analista/Desenvolvedor</td>
                      <td>

                        <div className="u_name">
                          <i className="c_name"> <i className="zmdi zmdi-email"></i> anibal.filho@fjp.mg.gov.br</i>
                          <br />
                          {/* <i className="phone"><i className="zmdi zmdi-phone"></i><span className='ml-1'>(33) 98803-1302</span></i> */}
                        </div>


                      </td>
                    </tr>



                    


                    <tr>
                      <td>
                        {/* <img className="rounded-circle" src="assets/images/xs/denilson-atic_50x50.jpg" alt="user" width="40" /> */}
                      </td>
                      <td>
                        <a href="javascript:void(0);" className='text-danger'> Livia Cristina Rosa Cruz </a>
                      </td>
                      <td>Pesquisadora</td>
                      <td>Teste de Qualidade</td>
                      <td>

                        <div className="u_name">
                          <i className="c_name"> <i className="zmdi zmdi-email"></i> livia.cruz@fjp.mg.gov.br  </i>
                          <br />
                          {/* <i className="phone"><i className="zmdi zmdi-phone"></i><span className='ml-1'>(31) 98618-5197</span></i> */}
                        </div>
                      </td>
                    </tr>

                   <tr>
                      <td>
                        {/* <img className="rounded-circle" src="assets/images/xs/denilson-atic_50x50.jpg" alt="user" width="40" /> */}
                      </td>
                      <td>
                        <a href="javascript:void(0);" className='text-danger'> Raimundo de Sousa Leal Filho </a>
                      </td>
                      <td>Pesquisador</td>
                      <td>Teste de Qualidade</td>
                      <td>

                        <div className="u_name">
                          <i className="c_name"> <i className="zmdi zmdi-email"></i> raimundo.sousa@fjp.mg.gov.br  </i>
                          <br />
                          {/* <i className="phone"><i className="zmdi zmdi-phone"></i><span className='ml-1'>(31) 98618-5197</span></i> */}
                        </div>
                      </td>
                    </tr>

     <tr>
                      <td>
                        {/* <img className="rounded-circle" src="assets/images/xs/denilson-atic_50x50.jpg" alt="user" width="40" /> */}
                      </td>
                      <td>
                        <a href="javascript:void(0);" className='text-danger'> Regis Costa Santos </a>
                      </td>
                      <td>Pesquisador</td>
                      <td>Teste de Qualidade</td>
                      <td>

                        <div className="u_name">
                          <i className="c_name"> <i className="zmdi zmdi-email"></i> regis.santos@fjp.mg.gov.br  </i>
                          <br />
                          {/* <i className="phone"><i className="zmdi zmdi-phone"></i><span className='ml-1'>(31) 98618-5197</span></i> */}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        {/* <img className="rounded-circle" src="assets/images/xs/denilson-atic_50x50.jpg" alt="user" width="40" /> */}
                      </td>
                      <td>
                        <a href="javascript:void(0);" className='text-danger'>Denilson Martins</a>
                      </td>
                      <td>Analista de Sistemas</td>
                      <td>Teste de Qualidade </td>
                      <td>

                        <div className="u_name">
                          <i className="c_name"> <i className="zmdi zmdi-email"></i> denilson.martins@fjp.mg.gov.br  </i>
                          <br />
                          {/* <i className="phone"><i className="zmdi zmdi-phone"></i><span className='ml-1'>(31) 98618-5197</span></i> */}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        {/* <img className="rounded-circle" src="assets/images/xs/denilson-atic_50x50.jpg" alt="user" width="40" />  */}
                      </td>
                      <td>
                        <a href="javascript:void(0);" className='text-danger'>João Brunno  </a>
                      </td>
                      <td>Analista de Sistemas</td>
                      <td>Teste de Qualidade</td>
                      <td>

                        <div className="u_name">
                          <i className="c_name"> <i className="zmdi zmdi-email"></i> joao.brunno@fjp.mg.gov.br  </i>
                          <br />
                          {/* <i className="phone"><i className="zmdi zmdi-phone"></i><span className='ml-1'>(31) 98618-5197</span></i> */}
                        </div>
                      </td>
                    </tr>


                    <tr>
                      <td>
                        {/* <img className="rounded-circle" src="assets/images/xs/denilson-atic_50x50.jpg" alt="user" width="40" /> */}
                      </td>
                      <td>
                        <a href="javascript:void(0);" className='text-danger'>Marcos Vieito </a>
                      </td>
                      <td>Analista de Sistemas</td>
                      <td>Teste de Qualidade</td>
                      <td>

                        <div className="u_name">
                          <i className="c_name"> <i className="zmdi zmdi-email"></i> marcos.vieito@fjp.mg.gov.br  </i>
                          <br />
                          {/* <i className="phone"><i className="zmdi zmdi-phone"></i><span className='ml-1'>(31) 98618-5197</span></i> */}
                        </div>
                      </td>
                    </tr>


                    <tr>
                      <td>
                        {/* <img className="rounded-circle" src="assets/images/xs/denilson-atic_50x50.jpg" alt="user" width="40" /> */}
                      </td>
                      <td>
                        <a href="javascript:void(0);" className='text-danger'>Renata Moreira </a>
                      </td>
                      <td>Analista de Sistemas</td>
                      <td>Teste de Qualidade</td>
                      <td>

                        <div className="u_name">
                          <i className="c_name"> <i className="zmdi zmdi-email"></i> renata.moreira@fjp.mg.gov.br  </i>
                          <br />
                          {/* <i className="phone"><i className="zmdi zmdi-phone"></i><span className='ml-1'>(31) 98618-5197</span></i> */}
                        </div>
                      </td>
                    </tr>


                  </tbody>
                </table>
              </div>
              <hr />
              <div className='ml-3'>
                <div className='card'>
                  <div className='header'>
                    <h2> <i className='zmdi zmdi-code-setting'></i> TECNOLOOGIAS UTILIZADAS  <small>OPEN SOURCE</small></h2>
                  </div>
                  <table className='table table-hover'>
                    <thead>
                      <th></th>
                      <th>DESCRICAO</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td><b>PHP/Laravel</b></td>
                        <td>
                          Laravel é um framework PHP livre e open-source para o desenvolvimento de sistemas web que utilizam o padrão MVC (model, view, controller)
                        </td>
                      </tr>
                      <tr>
                        <td><b>Python/Pandas</b></td>
                        <td>
                          Pandas é uma biblioteca de software criada para a linguagem Python para manipulação e análise de dados. Em particular, oferece estruturas e operações para manipular tabelas numéricas e séries temporais.
                        </td>
                      </tr>
                      <tr>
                        <td><b>NodeJS/JavaScript</b></td>
                        <td>
                          Node.js é um software de código aberto, multiplataforma, baseado no interpretador V8 do Google e que permite a execução de códigos JavaScript fora de um navegador web. A principal característica do Node.js é sua arquitetura assíncrona e orientada por eventos
                        </td>
                      </tr>
                      <tr>
                        <td><b>React JS</b></td>
                        <td>
                          O React é uma biblioteca front-end JavaScript de código aberto com foco em criar interfaces de usuário em páginas web.
                        </td>
                      </tr>
                     
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <hr />
            <b>VERSAO</b> 2.0
          </div>
        </div>
      </ContentBox>
    </>
  )
}